module.exports = __webpack_public_path__ + "static/media/logo-sebrae.9111ba08.svg";